export enum CheckoutModes {
    requiresRefund = 'requiresRefund',
    requiresPayment = 'requiresPayment',
}